import { render, staticRenderFns } from "./AddTransaction.vue?vue&type=template&id=a3daef00&scoped=true&"
import script from "./AddTransaction.vue?vue&type=script&lang=ts&"
export * from "./AddTransaction.vue?vue&type=script&lang=ts&"
import style0 from "./AddTransaction.vue?vue&type=style&index=0&id=a3daef00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3daef00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VIcon,VSpacer,VTextField,VToolbar})
